import React, { createContext, useCallback, useContext, useMemo } from "react";
import { toast, ToastContainer } from "react-toastify";
import PropTypes from 'prop-types';
import 'react-toastify/dist/ReactToastify.min.css';

const getDefaultToastOptions = (isDarkMode) => ({
    position: "bottom-right",
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: isDarkMode?"light":"light",
});

const ToastContext = createContext(undefined);

export const useToast = () => {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error("useToast must be used within a ToastProvider");
    }
    return context;
};

export const ToastProvider = ({ children }) => {
    //const theme = useTheme();
    const isDarkMode = false;

    const showSuccessToast = useCallback(
        (message) => {
            //console.log("Success Toast:", message);
            toast.success(message, {
                ...getDefaultToastOptions(isDarkMode),
                autoClose: 4000
            });

            
        },
        [isDarkMode]
    );

    const showErrorToast = useCallback(
        (message) => {
            toast.error(message, {
                ...getDefaultToastOptions(isDarkMode),
                autoClose: 4000
            });
        },
        [isDarkMode]
    );

    const showWarningToast = useCallback(
        (message) => {
            toast.warning(message, {
                ...getDefaultToastOptions(isDarkMode),
                autoClose: 4000,
            });
        },
        [isDarkMode]
    );

    const showInfoToast = useCallback(
        (message) => {
            toast.info(message, {
                ...getDefaultToastOptions(isDarkMode),
                autoClose: 4000,
            });
        },
        [isDarkMode]
    );

    const hideToast = useCallback((id) => {
        if (id) {
            toast.dismiss(id);
        } else {
            toast.dismiss();
        }
    }, []);

    const contextValue = useMemo(
        () => ({ showSuccessToast, showErrorToast, showWarningToast, showInfoToast, hideToast }),
        [showSuccessToast, showErrorToast, showWarningToast, showInfoToast, hideToast]
    );

    return (
        <ToastContext.Provider value={contextValue}>
            {children}
            <ToastContainer
                position="bottom-right"
                rtl={false}
            />
        </ToastContext.Provider>
    );
};

ToastProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ToastProvider;
